import { UserPayload } from "../models/SiteModel";

const URLAPI = process.env.REACT_APP_BASE_URL;

export interface PresupuestoLineaInput {
  idProducto: number;
  codigo: string;
  producto: string;
  cantidad: number;
  precio: number;
}

export interface GuardarPresupuestoInput {
  idCliente: number;
  idLocal: number;
  lineas: PresupuestoLineaInput[];
  formaPago: string;
  plazo: number;
  descuento: number;
  recargo: number;
  senia: number;
  idLista: number;
  total: number;
}

/** Guarda el presupuesto con sus condiciones comerciales y precios resueltos por la pantalla. */
export async function fetchGuardarPresupuesto(user: UserPayload, input: GuardarPresupuestoInput) {
    const payload = input.lineas.map((linea) => ({
      IdProducto: linea.idProducto,
      Codigo: linea.codigo,
      Producto: linea.producto,
      Cantidad: linea.cantidad,
      Precio: linea.precio,
    }));
    const postData = JSON.stringify({
      Request:{
        IdLocal: input.idLocal,
        IdCliente: input.idCliente,
        Cliente: "",
        IdEmpleado: 0,
        Total: input.total,
        FormaPago: input.formaPago,
        Descuento: input.descuento,
        Recargo: input.recargo,
        Usuario: user.username,
        Seña: input.senia,
        IdCaja: 0,
        IdLista: input.idLista,
        Plazo: input.plazo
      },
      Lineas: payload
    });
    const response = await fetch(
      `${URLAPI}/Presupuesto/GuardarPresupuesto`,
      {
        method: "POST", headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + user.token
        },
        body: postData
      }
    );
  
    const data = await response.json();
    if (!response.ok) {
      const validationMessages = Object.values(data.errors ?? {})
        .flatMap((messages: any) => Array.isArray(messages) ? messages : [messages])
        .filter(Boolean)
        .join(" ");
      throw new Error(data.message || validationMessages || data.title || "No se pudo guardar el presupuesto.");
    }
    return data;
}

export interface ConfiguracionPresupuestoWeb {
  habilitado: boolean;
  pv: number | null;
  permiteFotos: boolean;
  mensaje: string;
}


export async function fetchConfiguracionPresupuesto(user: UserPayload, idLocal: number): Promise<ConfiguracionPresupuestoWeb> {
  const response = await fetch(`${URLAPI}/Presupuesto/GetConfiguracion/${idLocal}`, {
    headers: { Authorization: `Bearer ${user.token}` },
  });
  if (!response.ok) throw new Error("No se pudo consultar la configuración del presupuesto.");
  return response.json();
}

export async function fetchDescargarPresupuestoPdf(user: UserPayload, idLocal: number, idPresupuesto: number, incluirFotos: boolean): Promise<Blob> {
  const response = await fetch(`${URLAPI}/Presupuesto/DescargarPdf/${idLocal}/${idPresupuesto}?incluirFotos=${incluirFotos}`, {
    headers: { Authorization: `Bearer ${user.token}` },
  });
  if (!response.ok) {
    const error = await response.json().catch(() => null);
    throw new Error(error?.message || "No se pudo generar el PDF. Puede volver a intentarlo.");
  }
  return response.blob();
}
